import { useTracking } from '@change-corgi/core-react/tracking';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionActionsPageData, usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';
import { getSupporterComments } from '#src/app/pages/actions/shared/api';

type Result = ModelHookResult<
	EmptyObject,
	{
		nextPage: () => Promise<void>;
	}
>;

export function useNextPage(): Result {
	const utilityContext = useUtilityContext();
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionActionsPageData();
	const [
		{ endCursor },
		{ addSupporterVoice, setEndCursor, setLastSupporterVoicesPage, setLoadingMoreSupporterVoices },
	] = usePetitionActionsPageState();
	const track = useTracking();

	const nextPage = async () => {
		setLoadingMoreSupporterVoices(true);
		if (endCursor) {
			void track('petition_actions_supporter_voice_view_more');
		}
		try {
			const {
				supporterVoices,
				isLastSupporterVoicesPage,
				endCursor: nextEndCursor,
			} = await getSupporterComments(endCursor, 3, petitionId, utilityContext);
			supporterVoices.forEach(addSupporterVoice);
			setLastSupporterVoicesPage(isLastSupporterVoicesPage);
			setEndCursor(nextEndCursor ?? undefined);
		} finally {
			setLoadingMoreSupporterVoices(false);
		}
	};

	return {
		data: {},
		actions: {
			nextPage,
		},
	};
}
